var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _circle, _ellipse, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigAddr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 78,
    viewBox: "0 0 90 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4727_76899)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 25H69H79C82.866 25 86 21.866 86 18C86 14.3337 83.1814 11.3257 79.5929 11.0248C78.2952 6.39509 74.0441 3 69 3C65.3364 3 62.0911 4.791 60.092 7.5452C59.1278 7.19248 58.0864 7 57 7C52.0294 7 48 11.0294 48 16C48 20.9706 52.0294 25 57 25Z",
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18 9.68629 20.6863 7 24 7H64C67.3137 7 70 9.68629 70 13V61C70 64.3137 67.3137 67 64 67H24C20.6863 67 18 64.3137 18 61V13Z",
    fill: "url(#paint0_linear_4727_76899)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25C32 23.8954 32.8954 23 34 23H62C63.1046 23 64 23.8954 64 25C64 26.1046 63.1046 27 62 27H34C32.8954 27 32 26.1046 32 25Z",
    fill: "#C6CFE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25C24 23.8954 24.8954 23 26 23C27.1046 23 28 23.8954 28 25C28 26.1046 27.1046 27 26 27C24.8954 27 24 26.1046 24 25Z",
    fill: "#C6CFE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35C24 33.8954 24.8954 33 26 33C27.1046 33 28 33.8954 28 35C28 36.1046 27.1046 37 26 37C24.8954 37 24 36.1046 24 35Z",
    fill: "#C6CFE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45C24 43.8954 24.8954 43 26 43C27.1046 43 28 43.8954 28 45C28 46.1046 27.1046 47 26 47C24.8954 47 24 46.1046 24 45Z",
    fill: "#C6CFE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35C32 33.8954 32.8954 33 34 33H62C63.1046 33 64 33.8954 64 35C64 36.1046 63.1046 37 62 37H34C32.8954 37 32 36.1046 32 35Z",
    fill: "#C6CFE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45C32 43.8954 32.8954 43 34 43H62C63.1046 43 64 43.8954 64 45C64 46.1046 63.1046 47 62 47H34C32.8954 47 32 46.1046 32 45Z",
    fill: "#C6CFE2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4727_76899)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 73H25H35C38.866 73 42 69.866 42 66C42 62.3337 39.1814 59.3257 35.5929 59.0248C34.2952 54.3951 30.0441 51 25 51C21.3364 51 18.0911 52.791 16.092 55.5452C15.1278 55.1925 14.0864 55 13 55C8.02944 55 4 59.0294 4 64C4 68.9706 8.02944 73 13 73Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 56,
    r: 13,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5,
    cy: 56,
    rx: 9.5,
    ry: 10,
    fill: "url(#paint1_linear_4727_76899)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6549 45.0001C62.7068 44.9899 64.7173 45.5979 66.441 46.75C68.1646 47.9021 69.527 49.5484 70.3618 51.4881C71.1965 53.4278 71.4676 55.577 71.142 57.6734C70.8164 59.7698 69.9081 61.7228 68.528 63.2941L71.7708 66.6174C71.8434 66.6926 71.9011 66.7819 71.9404 66.8801C71.9798 66.9784 72 67.0837 72 67.1901C72 67.2964 71.9798 67.4018 71.9404 67.5C71.9011 67.5983 71.8434 67.6876 71.7708 67.7628C71.6981 67.838 71.6118 67.8976 71.5168 67.9384C71.4219 67.9791 71.3201 68 71.2173 68C71.1145 68 71.0127 67.9791 70.9178 67.9384C70.8228 67.8976 70.7365 67.838 70.6638 67.7628L67.3743 64.3911C66.0684 65.5204 64.5187 66.3073 62.8565 66.685C61.1943 67.0628 59.4685 67.0203 57.8256 66.5611C56.1826 66.1019 54.6708 65.2396 53.4184 64.0472C52.166 62.8549 51.2099 61.3677 50.6311 59.7117C50.0522 58.0556 49.8678 56.2796 50.0934 54.5341C50.319 52.7887 50.948 51.1252 51.927 49.6848C52.906 48.2443 54.2062 47.0694 55.7174 46.2595C57.2286 45.4496 58.9063 45.0287 60.6081 45.0324L60.6549 45.0001ZM60.6549 65.3107C62.4446 65.3139 64.195 64.7674 65.6844 63.7405C67.1738 62.7136 68.3352 61.2524 69.0215 59.5421C69.7079 57.8317 69.8882 55.949 69.5398 54.1325C69.1914 52.316 68.3299 50.6473 67.0644 49.3378C65.7988 48.0282 64.1862 47.1368 62.4307 46.7762C60.6752 46.4157 58.8558 46.6024 57.2029 47.3126C55.55 48.0227 54.1379 49.2245 53.1455 50.7657C52.1531 52.3069 51.625 54.1181 51.6281 55.9701C51.6322 58.4461 52.5846 60.8194 54.2765 62.5702C55.9685 64.3209 58.2621 65.3064 60.6549 65.3107Z",
    fill: "#C6CFE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7566 51.7119C56.8411 51.6257 56.9416 51.5573 57.0523 51.5107C57.163 51.464 57.2818 51.44 57.4017 51.44C57.5217 51.44 57.6405 51.464 57.7512 51.5107C57.8619 51.5573 57.9624 51.6257 58.0469 51.7119L61.0454 54.7449L64.0258 51.7119C64.1969 51.5388 64.429 51.4416 64.671 51.4416C64.9129 51.4416 65.145 51.5388 65.3161 51.7119C65.4872 51.8849 65.5833 52.1197 65.5833 52.3644C65.5833 52.6092 65.4872 52.8439 65.3161 53.017L62.3175 56.05L65.2434 59.0646C65.3281 59.1503 65.3953 59.252 65.4412 59.364C65.487 59.476 65.5106 59.596 65.5106 59.7171C65.5106 59.8383 65.487 59.9583 65.4412 60.0703C65.3953 60.1823 65.3281 60.284 65.2434 60.3697C65.1587 60.4554 65.0581 60.5234 64.9474 60.5698C64.8367 60.6161 64.7181 60.64 64.5983 60.64C64.4785 60.64 64.3598 60.6161 64.2491 60.5698C64.1384 60.5234 64.0378 60.4554 63.9531 60.3697L60.9546 57.3367L57.9742 60.3697C57.8031 60.5428 57.571 60.64 57.329 60.64C57.0871 60.64 56.855 60.5428 56.6839 60.3697C56.5128 60.1966 56.4167 59.9619 56.4167 59.7171C56.4167 59.4724 56.5128 59.2377 56.6839 59.0646L59.7915 56.05L56.7929 53.017C56.7053 52.934 56.6349 52.8343 56.5856 52.7236C56.5363 52.6129 56.5092 52.4934 56.5058 52.3721C56.5025 52.2507 56.5229 52.1299 56.5659 52.0166C56.6089 51.9033 56.6738 51.7997 56.7566 51.7119Z",
    fill: "#C6CFE2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6549 45.0001C62.7068 44.9899 64.7173 45.5979 66.441 46.75C68.1646 47.9021 69.527 49.5484 70.3618 51.4881C71.1965 53.4278 71.4676 55.577 71.142 57.6734C70.8164 59.7698 69.9081 61.7228 68.528 63.2941L71.7708 66.6174C71.8434 66.6926 71.9011 66.7819 71.9404 66.8801C71.9798 66.9784 72 67.0837 72 67.1901C72 67.2964 71.9798 67.4018 71.9404 67.5C71.9011 67.5983 71.8434 67.6876 71.7708 67.7628C71.6981 67.838 71.6118 67.8976 71.5168 67.9384C71.4219 67.9791 71.3201 68 71.2173 68C71.1145 68 71.0127 67.9791 70.9178 67.9384C70.8228 67.8976 70.7365 67.838 70.6638 67.7628L67.3743 64.3911C66.0684 65.5204 64.5187 66.3073 62.8565 66.685C61.1943 67.0628 59.4685 67.0203 57.8256 66.5611C56.1826 66.1019 54.6708 65.2396 53.4184 64.0472C52.166 62.8549 51.2099 61.3677 50.6311 59.7117C50.0522 58.0556 49.8678 56.2796 50.0934 54.5341C50.319 52.7887 50.948 51.1252 51.927 49.6848C52.906 48.2443 54.2062 47.0694 55.7174 46.2595C57.2286 45.4496 58.9063 45.0287 60.6081 45.0324L60.6549 45.0001ZM60.6549 65.3107C62.4446 65.3139 64.195 64.7674 65.6844 63.7405C67.1738 62.7136 68.3352 61.2524 69.0215 59.5421C69.7079 57.8317 69.8882 55.949 69.5398 54.1325C69.1914 52.316 68.3299 50.6473 67.0644 49.3378C65.7988 48.0282 64.1862 47.1368 62.4307 46.7762C60.6752 46.4157 58.8558 46.6024 57.2029 47.3126C55.55 48.0227 54.1379 49.2245 53.1455 50.7657C52.1531 52.3069 51.625 54.1181 51.6281 55.9701C51.6322 58.4461 52.5846 60.8194 54.2765 62.5702C55.9685 64.3209 58.2621 65.3064 60.6549 65.3107Z",
    stroke: "#C6CFE2",
    strokeWidth: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7566 51.7119C56.8411 51.6257 56.9416 51.5573 57.0523 51.5107C57.163 51.464 57.2818 51.44 57.4017 51.44C57.5217 51.44 57.6405 51.464 57.7512 51.5107C57.8619 51.5573 57.9624 51.6257 58.0469 51.7119L61.0454 54.7449L64.0258 51.7119C64.1969 51.5388 64.429 51.4416 64.671 51.4416C64.9129 51.4416 65.145 51.5388 65.3161 51.7119C65.4872 51.8849 65.5833 52.1197 65.5833 52.3644C65.5833 52.6092 65.4872 52.8439 65.3161 53.017L62.3175 56.05L65.2434 59.0646C65.3281 59.1503 65.3953 59.252 65.4412 59.364C65.487 59.476 65.5106 59.596 65.5106 59.7171C65.5106 59.8383 65.487 59.9583 65.4412 60.0703C65.3953 60.1823 65.3281 60.284 65.2434 60.3697C65.1587 60.4554 65.0581 60.5234 64.9474 60.5698C64.8367 60.6161 64.7181 60.64 64.5983 60.64C64.4785 60.64 64.3598 60.6161 64.2491 60.5698C64.1384 60.5234 64.0378 60.4554 63.9531 60.3697L60.9546 57.3367L57.9742 60.3697C57.8031 60.5428 57.571 60.64 57.329 60.64C57.0871 60.64 56.855 60.5428 56.6839 60.3697C56.5128 60.1966 56.4167 59.9619 56.4167 59.7171C56.4167 59.4724 56.5128 59.2377 56.6839 59.0646L59.7915 56.05L56.7929 53.017C56.7053 52.934 56.6349 52.8343 56.5856 52.7236C56.5363 52.6129 56.5092 52.4934 56.5058 52.3721C56.5025 52.2507 56.5229 52.1299 56.5659 52.0166C56.6089 51.9033 56.6738 51.7997 56.7566 51.7119Z",
    stroke: "#C6CFE2",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4727_76899",
    x: 44,
    y: 0,
    width: 46,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591458 0 0 0 0 0.623225 0 0 0 0 0.695833 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4727_76899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4727_76899",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4727_76899",
    x: 0,
    y: 48,
    width: 46,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591458 0 0 0 0 0.623225 0 0 0 0 0.695833 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4727_76899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4727_76899",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4727_76899",
    x1: 44,
    y1: 7,
    x2: 44,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4727_76899",
    x1: 57.4824,
    y1: 51.4612,
    x2: 61.1155,
    y2: 64.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE6FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigAddr);
export default __webpack_public_path__ + "static/media/big-addr.d2b13233f43925665485df7f10854701.svg";
export { ForwardRef as ReactComponent };